import { Directive, ElementRef, Input, OnChanges, SimpleChanges } from '@angular/core';
import { EnvironmentService } from '@tekman/onmat/service/generic';
import { createWidget } from '@typeform/embed';
import { StorageService } from '@tekman/shared/service';
import { Language } from '@tekman/onmat/constants';

@Directive({
  selector: '[typeform]',
})
export class TypeformDirective implements OnChanges {
  @Input() typeform: any;

  constructor(private el: ElementRef, private storageService: StorageService, private readonly environment: EnvironmentService) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['typeform']?.currentValue) {
      const idTypeform = this.getIdTypform();
      createWidget(idTypeform, {
        container: this.el.nativeElement,
        transitiveSearchParams: ['activity_id', 'region', 'env', 'course', 'unit', 'tipology', 'activity', 'schoolid', 'name', 'email'],
        hidden: this.typeform,
        iframeProps: {
          height: '500px',
        },
      });
    }
  }

  private getIdTypform() {
    switch (this.storageService.languageLicense) {
      case Language.ESP:
      case Language.ECU:
      case Language.MEX:
        return this.environment.settings.typeform.idEsp;
      case Language.CAT:
        return this.environment.settings.typeform.idCat;
      case Language.ENG:
        return this.environment.settings.typeform.idEn;
    }
  }
}
